module.exports = __webpack_public_path__ + "media/reskin-images/icon--heart-5332116e.svg";